var $4a0a0b446cb90faa$exports = {};
$4a0a0b446cb90faa$exports = {
    "endTime": `\u{5E9}\u{5E2}\u{5EA} \u{5E1}\u{5D9}\u{5D5}\u{5DD}`,
    "startTime": `\u{5E9}\u{5E2}\u{5EA} \u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5D4}`,
    "time": `\u{5D6}\u{5DE}\u{5DF}`
};


export {$4a0a0b446cb90faa$exports as default};
//# sourceMappingURL=he-IL.mjs.map
